/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	DataRemovalRequestRejectPathParams,
	DataRemovalRequestRejectRequest,
	DataRemovalRequestRejectResponse,
} from '../types/DataRemovalRequestReject'

/**
 * POST /organisations/:organisation/data-removal-requests/:dataRemovalRequest/reject
 * @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::reject
 */
export async function dataRemovalRequestReject(
	organisation: DataRemovalRequestRejectPathParams['organisation'],
	dataRemovalRequest: DataRemovalRequestRejectPathParams['dataRemovalRequest'],
	data: DataRemovalRequestRejectRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<DataRemovalRequestRejectResponse>> {
	return axiosInstance.post(
		`/organisations/${organisation}/data-removal-requests/${dataRemovalRequest}/reject`,
		data,
		config,
	)
}
